<app-crear-form-paciente
  [response]="response"
  [editar]="editar"
></app-crear-form-paciente>
